import React from 'react';
import Link from 'gatsby-link'

const VoucherAd = () => (
  <div className="callout text-center">
    <h4>Experience Days</h4>
    <p>
      <strong>Book one of our 4x4 experience day vouchers</strong>
      <br/>
      Ideal birthday presents and Christmas gifts
    </p>
    <Link className="button secondary uppercase" to="/bookings">Bookings</Link>
  </div>
);

export default VoucherAd;



// WEBPACK FOOTER //
// ./src/components/voucher-ad.js